// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__PNj-6","head__title":"styles_head__title__T7COH"};